import React, { useEffect, useState } from "react";
import Header from "./Header";
import axios from "axios";
import Footer from "../LandingPage/Footer";
import { useNavigate } from "react-router-dom";

const CategoriesWeb = () => {

    
    const navigate = useNavigate();
    const [activePage, setActivePage] = useState("categories");

    /* ---------------- DATA ---------------- */

    const [categories, setCategories] = useState([]);
    const [properties, setProperties] = useState([]);

    useEffect(() => {
        fetchAllData();
    }, []);

    const fetchAllData = async () => {
        try {
            const [catRes, propRes] = await Promise.all([
                axios.get("https://api.propertygalleria.in/api/property-categories"),
                axios.get(
                    "https://api.propertygalleria.in/master/api/api/owner/properties"
                ),
            ]);
            console.log("Properties API:", propRes.data.data);

            setCategories(catRes.data);
            setProperties(propRes.data.data);
        } catch (error) {
            console.error("API Error:", error);
        }
    };

    // count properties by category
    const getProductCount = (categoryName) => {
        return properties.filter(
            (item) =>
                item.category &&
                item.category.toLowerCase() === categoryName.toLowerCase()
        ).length;
    };

    return (

        <>
            <Header />
            <div></div>
            <div style={{ padding: 30, maxWidth: 900, margin: "auto", marginTop: '60px' }}>

                {/* HEADER */}
                <div style={header}>
                    {activePage !== "categories" && (
                        <span style={backBtn} onClick={() => setActivePage("categories")}>
                            ← Back to Categories
                        </span>
                    )}
                    <h2>Categories</h2>
                </div>

                {/* ---------------- CATEGORY LIST ---------------- */}
                {activePage === "categories" && (
                    <>
                           {categories.map((cat) => {
                            const count = getProductCount(cat.category_name);

                            // show only if products exist
                            // if (count === 0) return null;

                            return (
                                <CategoryCard
                                    key={cat.id}
                                    title={cat.category_name}
                                    count={`${count} Properties`}
                                    color={cat.color || "#e3f2fd"}
                                    // onClick={() =>
                                    //     console.log("Navigate to", cat.category_name)
                                    // }
                                    onClick={() => navigate("/properties")}
                                />
                            );
                        })}
                    </>
                )}

                {/* ---------------- PROPERTY LIST ---------------- */}
                {activePage !== "categories" && (
                    <>
                        <h3 style={{ margin: "20px 0" }}>
                            {activePage.charAt(0).toUpperCase() + activePage.slice(1)} Properties (
                            {properties[activePage].length})
                        </h3>

                        {properties[activePage].map((item, index) => (
                            <PropertyCard key={index} data={item} label={activePage} />
                        ))}
                    </>
                )}
            </div>


             <Footer/>
        </>
    );
};

/* ---------------- COMPONENTS ---------------- */

const CategoryCard = ({ title, count, color, onClick }) => (
    <div onClick={onClick} style={categoryCard}>
        <div style={{ ...iconBox, background: color }}>🏢</div>
        <div>
            <h3>{title}</h3>
            <p style={{ color: "#666" }}>{count}</p>
        </div>
        <span style={{ marginLeft: "auto", fontSize: 22 }}>→</span>
    </div>
);

const PropertyCard = ({ data, label }) => (
    <div style={propertyCard}>
        <div style={{ position: "relative" }}>
            <img src={data.image} alt="" style={image} />
            <span style={premium}>Premium</span>
            <span style={heart}>♡</span>
        </div>

        <div style={{ padding: 15 }}>
            <h3>{data.title}</h3>
            <p style={{ color: "#666" }}>📍 {data.location}</p>

            <div style={priceRow}>
                <span style={{ color: "#2563eb", fontWeight: "bold" }}>{data.price}</span>
                <span>{data.area}</span>
            </div>

            <span style={badge}>{label}</span>
        </div>
    </div>
);

/* ---------------- STYLES ---------------- */

const header = {
    display: "flex",
    alignItems: "center",
    gap: 15,
    marginBottom: 20
};

const backBtn = {
    cursor: "pointer",
    color: "#2563eb"
};

const categoryCard = {
    display: "flex",
    alignItems: "center",
    padding: 20,
    marginBottom: 20,
    background: "#fff",
    borderRadius: 16,
    boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
    cursor: "pointer"
};

const iconBox = {
    width: 60,
    height: 60,
    borderRadius: 16,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    fontSize: 26,
    marginRight: 20
};

const propertyCard = {
    background: "#fff",
    borderRadius: 18,
    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
    marginBottom: 30,
    overflow: "hidden"
};

const image = {
    width: "100%",
    height: 220,
    objectFit: "cover"
};

const premium = {
    position: "absolute",
    top: 12,
    left: 12,
    background: "#fbbf24",
    padding: "6px 14px",
    borderRadius: 20,
    color: "#fff",
    fontSize: 12
};

const heart = {
    position: "absolute",
    top: 12,
    right: 12,
    background: "#fff",
    width: 36,
    height: 36,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
};

const priceRow = {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 10
};

const badge = {
    display: "inline-block",
    marginTop: 12,
    padding: "6px 14px",
    borderRadius: 20,
    background: "#e0ecff",
    color: "#2563eb",
    fontSize: 12
};

export default CategoriesWeb;
